module.exports = __webpack_public_path__ + "img/SHOWMAX.17051234.svg";